module.exports = __webpack_public_path__ + "static/1-cfa20889bbf8ebf15518137ce1a6ac70.jpeg";